import { Component, NgZone, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController, Platform } from '@ionic/angular';
import { AuthenticationService } from '../../_services';
import { LocalNotifications } from '@ionic-native/local-notifications/ngx';
import { CloseOverlayService } from '../../_services/closeOverlay.service';
import { PaymentsStore } from '../../_services/store';

@Component({
  selector: 'app-payment-success',
  templateUrl: './payment-success.page.html',
  styleUrls: ['./payment-success.page.scss'],
  providers: [LocalNotifications]
})
export class PaymentSuccessPage implements OnInit {
  buttonText = '';
  amount = this.paymentsStore.getAmount();
  paymentMethod = this.paymentsStore.getPaymentMethod();
  subscription: any;

  constructor(
    private zone: NgZone,
    private router: Router,
    private platform: Platform,
    private auth: AuthenticationService,
    private paymentsStore: PaymentsStore,
    private modalController: ModalController,
    private localNotifications: LocalNotifications,
    private closeOverlayService: CloseOverlayService
  ) { }

  successAction() {
    this.paymentsStore.removeAmount();
    this.closeOverlayService.trigger();
    this.modalController.dismiss();
    if (this.auth.currentUserValue) {
      this.buttonText = 'Go to Dashboard';
      this.router.navigate(['/dashboard']);
    } else {
      this.buttonText = 'Sign Up Now';
      this.router.navigate(['/signup']);
    }
  }

  ionViewDidEnter() {
    if (this.paymentMethod === 'bankTransfer') {
      this.paymentMethod = 'Bank Transfer';
    } else {
      this.paymentMethod = 'USSD Transfer';
    }
    if (this.auth.currentUserValue.role !== 'merchant') {
      this.localNotifications.schedule([
        {
          id: new Date().getTime(),
          title: 'New Transaction Alert',
          text: this.paymentMethod + ' of ' + '₦' + this.amount + ' was just paid into your wallet',
        }
      ]);
      this.localNotifications.on('click')
      .subscribe(
        response => {
          console.log('Open notification and go to Dashboard', response);
          this.zone.run(() => {
            this.closeOverlayService.trigger();
            this.router.navigateByUrl('/dashboard');
          });
        }, error => {
          console.log(error);
        }
      );
    }
    this.subscription = this.platform.backButton.subscribeWithPriority(99999, () => {
      console.log('Don\'t go back');
    });
  }

  ionViewDidLeave() {
    console.log('Left payment success page');
    this.subscription.unsubscribe();
  }

  ngOnInit() {
    if (this.auth.currentUserValue) {
      this.buttonText = 'Go to Dashboard';
    } else {
      this.buttonText = 'Sign Up Now';
    }
  }

}
